import classNames from 'classnames';

import { useBrandingConfig } from '../../hooks/branding';

import './index.scss';

function AuthLogo() {
  const { logo } = useBrandingConfig();
  return (
    <div
      className={classNames('AuthLogo alk-flex', {
        'AuthLogo--large': logo.large,
      })}
    >
      <img src={logo.src.loginUK} alt={logo.alt} />
    </div>
  );
}

export default AuthLogo;
